import { render, staticRenderFns } from "./peoSave.vue?vue&type=template&id=352963c3&scoped=true&"
import script from "./peoSave.vue?vue&type=script&lang=js&"
export * from "./peoSave.vue?vue&type=script&lang=js&"
import style0 from "./peoSave.vue?vue&type=style&index=0&id=352963c3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352963c3",
  null
  
)

export default component.exports